import { Helmet } from "react-helmet-async";
import envConstants from "../Constants";
const ReturnPolicy = () => {
    const canonicalUrl = 'https://autopartstation.com.au/return-policy';
    const schemaMarkup = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Return Policy - Auto Part Station",
        "url": "https://autopartstation.com.au/return-policy",
        "mainEntity": {
            "@type": "Organization",
            "name": "Auto Part Station Pty Ltd",
            "url": "https://autopartstation.com.au",
            "logo": "https://autopartstation.com.au/auto-part.png"
        }
    };
    return (
        <div className="container my-4">
            <Helmet>
                <title>Return Policy - Auto Part Station | Hassle-Free Returns</title>
                <meta name="description" content="Review Auto Part Station's return policy. Easy returns and exchanges for your satisfaction guaranteed!" />
                <meta name="author" content={envConstants.STORE_META_AUTHOR ? envConstants.STORE_META_AUTHOR : 'Auto Part Station Store'} />
                <meta name="keywords" content="Auto Part Station return policy, return policy Auto Part Station" />
                <link rel="canonical" href={canonicalUrl} />
                <script type="application/ld+json">
                    {JSON.stringify(schemaMarkup)}
                </script>
            </Helmet>
            <h2>Return Policy</h2>
            <p>At <strong>Auto Part Station</strong>, your satisfaction is our priority. We understand that sometimes a product may not meet your expectations or could arrive with unforeseen issues. That’s why we’ve crafted a clear and customer-friendly Return & Refund Policy—to give you peace of mind with every purchase.</p>
            <h5>Easy Returns Within 30 Days</h5>
            <p>
                If you’re not completely satisfied with your purchase, you may return the product within <strong>30 days of the delivery date</strong> for a <strong>full refund</strong>.
                <br />To qualify for a return:</p>
            <ul>
                <li>The item must be <strong>unused</strong>, in <strong>original packaging</strong>, securely taped for transit</li>
                <li>All parts, accessories, and documentation must be included.</li>
                <li>Items must be in <strong>"NEW" condition;</strong> returns showing signs of use may not be accepted.</li>
            </ul>
            <h5>Simple Return Process</h5>
            <p>Returning your item is easy. Just contact our Customer Support Team via <strong>email</strong> or <strong>phone</strong> to start the process:</p>
            <p>
                <span><strong>Email:</strong> <a href="mailto:sales@autopartstation.com.au" className="text-decoration-none text-dark">sales@autopartstation.com.au</a></span>
                <br />
               <span><strong>Phone:</strong> <a href="tel:+61490533318" className="text-decoration-none text-dark">+61 490 533 318</a></span>
            </p>
            <p>We’ll provide you with a Return Authorisation Number and return instructions. Please note that return shipping costs are the buyer’s responsibility unless the return is due to a damaged or faulty product.</p>
            <h5>Damaged or Faulty Items</h5>
            <p>
            We take great care in packaging your order, but if you receive a product that is <strong>damaged in transit</strong> or has a <strong>manufacturing defect</strong>, please notify us within <strong>24 to 48 hours</strong> of receiving it.
            <br />
            Our support team will promptly assist you with a replacement, repair, or refund—whichever suits your situation best.
            </p>
            <h5>Fast Refunds</h5>
            <p>Once your returned item is received and inspected by our team, we will process your refund within <strong>5 business days</strong>. Refunds are issued to your original payment method.</p>
            <h5>No Restocking Fees</h5>
            <p>We do <strong>not</strong> charge any restocking fees on returned items. Our goal is to make your return experience as smooth and stress-free as possible.</p>
            <h5>Order Cancellations & Modifications</h5>
            <p>Need to change or cancel your order? No worries—just contact us within <stong>24 hours</stong> of placing your order. If your order hasn’t entered the fulfillment stage, we’ll make the changes or cancel it for you, no questions asked.</p>
            <h5>Customer Support</h5>
            <p>We’re here to help—whether it’s a return, refund, product query, or anything in between.</p>
            <p>
               <span><strong>Email:</strong> <a href="mailto:sales@autopartstation.com.au" className="text-decoration-none text-dark">sales@autopartstation.com.au</a></span>
               <br />
               <span><strong>Phone:</strong> <a href="tel:+61490533318" className="text-decoration-none text-dark">+61 490 533 318</a></span>
               <br />
               <span><strong>Operating Hours:</strong> Monday – Sunday | 8:00 AM – 6:00 PM AEST</span>
            </p>
            <p>Thank you for choosing <strong>Auto Part Station</strong>. Shop with confidence knowing we’ve got your back—before, during, and after your purchase.</p>
        </div>
    )
}

export default ReturnPolicy;